import React from "react";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Typography } from "@mui/material";
import TeamsLogo from "assets/img/TeamsLogo.png";

import { TStep } from "../TeamsIntegrationModal.types";

import { AlertColor } from "@/util/constants";

interface ITeamsIntegrationModalHeaderProps {
  callbackClose: (_message?: string, _color?: AlertColor) => void;
  step: TStep;
}

export const TeamsIntegrationModalHeader: React.FC<ITeamsIntegrationModalHeaderProps> = ({
  callbackClose,
  step,
}) => {
  const isTeamsLogoVisible = step === "fileList" || step === "metadata" || step === "review";

  return (
    <Box className="modal-kb-header flow-column" gap={1}>
      <Box className="flex space-between">
        {isTeamsLogoVisible && (
          <Box className="flex" alignItems="center">
            <img
              src={TeamsLogo}
              alt="teams icon"
              width="20px"
              height="20px"
              style={{ marginRight: "5px" }}
            />
            <Typography fontSize="20px">Teams Import</Typography>
          </Box>
        )}
        <button
          onClick={() => callbackClose()}
          data-testid="modalTeamsIntegration-close-button"
          className="close_icon"
        >
          <Icon icon="bitcoin-icons:cross-filled" height={30} color="#000000" />
        </button>
      </Box>
      <Box className="flex space-between">
        {step === "metadata" && (
          <Typography>
            Select file(s) on the left-hand side then add details on the right. Click "Save" when
            completed for all file attachments.
          </Typography>
        )}
        {step === "review" && (
          <>
            <Typography>Review and confirm the following information.</Typography>
            <Box className="flex" alignItems="center">
              <Icon icon="carbon:warning" height={14} />
              <Typography marginLeft={"5px"}>
                Previously uploaded files will be replaced if they already exist in the same
                directory
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
